export default __webpack_public_path__ + "static/icon_sprite-b94102647e7aaee16505f56ed3202683.svg";